import type { Npc, RoomDef } from '../defs.ts'
import { look } from '../town/kit.ts'

export const room: RoomDef = {
  id: 'cafe',
  name: 'Moonbean Café',
  blurb: 'Warm drinks, low lamps, long conversations.',
  w: 12, d: 10, outdoor: false, ground: 'planks', accent: '#e9a46b',
  wall: { color: '#f4e6d6', trim: '#c98d62' },
  zones: [],
  spawn: [5, 6],
  props: [
    { kind: 'rug', x: 1.6, y: 3.4, w: 8.8, d: 5, color: '#e9a46b' },
    { kind: 'counter', x: 1, y: 1, w: 5 },
    { kind: 'piano', x: 8, y: 1 },
    { kind: 'shelf', x: 0, y: 7, rot: 1 },
    { kind: 'table', x: 3, y: 4 }, { kind: 'chair', x: 2, y: 4, face: 1 }, { kind: 'chair', x: 4, y: 4, face: -1 },
    { kind: 'table', x: 7, y: 4 }, { kind: 'chair', x: 6, y: 4, face: 1 }, { kind: 'chair', x: 8, y: 4, face: -1 },
    { kind: 'table', x: 3, y: 7 }, { kind: 'chair', x: 2, y: 7, face: 1 }, { kind: 'chair', x: 4, y: 7, face: -1 },
    { kind: 'table', x: 7, y: 7 }, { kind: 'chair', x: 6, y: 7, face: 1 }, { kind: 'chair', x: 8, y: 7, face: -1 },
    { kind: 'sofa', x: 10, y: 3, rot: 1, face: -1, color: '#7d8fd6' },
    { kind: 'plant', x: 11, y: 1 }, { kind: 'plant', x: 11, y: 9 }, { kind: 'plant', x: 0, y: 9 },
    { kind: 'lamp', x: 11, y: 6 },
  ],
  walls: [
    { kind: 'board', wall: 'back', at: 1.4, len: 2.6, text: 'MENU' },
    { kind: 'clock', wall: 'back', at: 4.6, len: 0.8 },
    { kind: 'window', wall: 'back', at: 6.2, len: 1.8 },
    { kind: 'window', wall: 'back', at: 9.1, len: 1.8 },
    { kind: 'painting', wall: 'left', at: 1.2, len: 1.3, color: '#ff9e6b' },
    { kind: 'door', wall: 'left', at: 4, len: 1 },
    { kind: 'neon', wall: 'left', at: 6.4, len: 2.6, text: 'moonbean', color: '#ffb36b' },
  ],
  portals: [{ x: 0, y: 4, to: 'town', out: [1, 4], label: 'Outside' }],
  critters: [{ kind: 'cat', loop: [[9.5, 6.2], [9.4, 8.6], [5.2, 9.3], [1.4, 9.2], [1.5, 5.8], [5.5, 2.6], [9.6, 2.4]], speed: 0.45 }],
  places: [], spots: [], cap: 30, softCap: 22,
}

export const npcs: Npc[] = [
  {
    id: 'npc-barista', name: 'Mocha', role: 'Barista', look: look('baristamoc', 2, 1, 3, 'chef'), speed: 1.4,
    stops: [
      { x: 2, y: 0, wait: 8, say: -1 },
      { x: 5, y: 0, wait: 8, emote: 'happy' },
      { x: 3, y: 0, wait: 6, say: -1 },
      { x: 6, y: 1, wait: 5 },
      { x: 6, y: 6, wait: 5, emote: 'wink', say: -1 },
      { x: 6, y: 1, wait: 2 },
    ],
    lines: ['One oat latte, coming up!', 'Cake of the day: moon-berry.', 'Take a seat, I’ll bring it over.', 'Careful, it’s hot!', 'The cat is not for sale. Sorry.'],
  },
  {
    id: 'npc-reader', name: 'Professor Dew', role: 'Regular', look: look('profdew', 1, 15, 1, 'beret'), speed: 1,
    stops: [
      { x: 10, y: 4, wait: 40, emote: 'thinking', say: -1 },
      { x: 1, y: 7, wait: 12, say: -1 },
      { x: 10, y: 3, wait: 30, nap: true },
    ],
    lines: ['Mm. Chapter twelve is a doozy.', 'Have you read anything good lately?', 'This sofa is my office.', 'Shh… the plot is thickening.'],
  },
]
